import React, { FC } from 'react';

import classNames from 'classnames';

import { EvSection, EvTextInputSearch } from '@evinced-private/ui-common';

import './SearchFilter.scss';

interface IPropertiesFilter {
	searchInputValue: string;
	onInputChange: (value: string) => void;
	withBottomMargin?: boolean;
}

export const SearchFilter: FC<IPropertiesFilter> = ({
	searchInputValue,
	onInputChange,
	withBottomMargin = true
}) => {
	return (
		<div className={classNames('search-filter', { 'with-bottom-margin': withBottomMargin })}>
			<EvSection ariaLabel="Search filter">
				<div className="search-input">
					<EvTextInputSearch
						value={searchInputValue}
						onChange={onInputChange}
						onConfirm={() => onInputChange(searchInputValue)}
					/>
				</div>
			</EvSection>
		</div>
	);
};
